module.exports = __webpack_public_path__ + "static/media/arrow_up-pink.004193c0.svg";